import React, { Component, ReactNode } from 'react';
import { localeService } from '../../services';
import { Platform, AppView, DeviceType } from 'sofa-reborn-react';
import styled from 'styled-components';

import SkapaInlineMessage from '@ingka/inline-message';
import SkapaHyperLink from '@ingka/hyperlink';
import SkapaText from '@ingka/text';
import InformationCircleIconPaths from '@ingka/ssr-icon/paths/information-circle';
import WarningTriangleIconPaths from '@ingka/ssr-icon/paths/warning-triangle';

const BannerContainer = styled.div<{
	appView: AppView;
	platform: Platform;
	top: string;
	left: string;
}>`
	${(props) =>
		props.appView === 'summary-page'
			? 'display: flex;'
			: 'position: absolute;top:' + props.top + ';left:' + props.left + ';'};
	padding: ${(props) => (props.platform === 'kiosk' ? '32px' : '16px')};
	max-width: ${(props) => (props.appView === 'build-view' ? '670px' : '790px')};

	[data-element-name='kompis-inline-message'] {
		width: auto;
	}
`;

type Props = {
	platform: Platform;
	deviceType: DeviceType;
	appView: AppView;
	bannerMessageType: string;
	top: string;
	left: string;
	onBannerClose?: () => void;
};

/**
 * React component.
 *
 */
export default class Banner extends Component<Props> {
	/**
	 * React render method.
	 *
	 * @returns React node.
	 */
	public render(): ReactNode {
		const { props } = this;
		const { onBannerClose } = props;
		const bannerIcon =
			props.bannerMessageType === 'Cautionary'
				? WarningTriangleIconPaths
				: InformationCircleIconPaths;
		const InlineMessageTitle =
			props.platform === 'kiosk'
				? localeService.getTranslation('plannerBannerMessageTitleKiosk')
				: localeService.getTranslation('plannerBannerMessageTitle');
		const InlineMessageContent =
			props.platform === 'kiosk' ? (
				<SkapaText tagName={'p'} bodySize={'m'}>
					{localeService.getTranslation('plannerBannerMessageBodyKiosk')}
				</SkapaText>
			) : (
				<SkapaHyperLink
					colour={''}
					text={localeService.getTranslation('plannerBannerMessageLinkText')}
					url={localeService.getUrl('plannerBannerMessageLinkURL')}
					newWindow={true}
				></SkapaHyperLink>
			);
		return (
			<BannerContainer
				id="bannerContainer"
				appView={props.appView}
				platform={props.platform}
				top={props.top}
				left={props.left}
				aria-label={localeService.getTranslation('supplyDisclaimer')}
			>
				<SkapaInlineMessage
					variant={'informative'}
					title={InlineMessageTitle}
					body={InlineMessageContent}
					labelCloseButton={localeService.getTranslation('supplyDisclaimerClose')}
					dismissable={true}
					ssrIcon={bannerIcon}
					onDismissClick={onBannerClose}
				/>
			</BannerContainer>
		);
	}
}
